<template>
  <md-card class="md-layout-item md-size-50 md-layout--status">
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>sports_soccer</md-icon>
      </div>
      <h4 class="title">
        <strong>General: {{game.local.name}} vs {{game.visitor.name}}</strong><small>|</small><small> {{dateFormat()}}</small> 
        <badge type="danger" v-if="game.status != 'Finished' || game.status != 'Pending'">{{$t("games.stats.live")}} : {{stats.live}}</badge>
        <badge type="danger" v-if="game.status == 'Finished' || game.status == 'Pending'">{{$t("games.stats.maxLive")}} : {{stats.maxLive}}</badge>
      </h4>
    </md-card-header>

    <md-card-content>
      <md-field>
        <label>{{$t("games.status.gap")}}</label>
        <md-input type="number" v-model="actualMinutes"></md-input>
        <span class="md-helper-text">Aqui puedes corregir el tiempo del partido actual</span>
      </md-field>
      <h4 class="md-caption">{{$t("games.status.title")}}</h4>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-layout">
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'Pending'}" @click="changeStatusGame('pending')">{{$t("games.status.pending")}}</md-button>
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'BeforeMatch'}" @click="changeStatusGame('beforeMatch')">{{$t("games.status.beforeMatch")}}</md-button>
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'FirstHalf'}" @click="changeStatusGame('firstHalf')">{{$t("games.status.firstHalf")}}</md-button>
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'Halftime'}" @click="changeStatusGame('halftime')">{{$t("games.status.halfTime")}}</md-button> 
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'SecondHalf'}" @click="changeStatusGame('secondHalf')">{{$t("games.status.secondHalf")}}</md-button> 
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'ExtraTime'}" @click="changeStatusGame('extraTime')">{{$t("games.status.extraTime")}}</md-button>
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'Penalties'}" @click="changeStatusGame('penalties')">{{$t("games.status.penalties")}}</md-button>
          <md-button class="md-layout-item md-wd" :class="{'md-primary': game.status == 'Finished'}" @click="changeStatusGame('finalize')">{{$t("games.status.finalize")}}</md-button>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import moment from 'moment';
import { Badge } from '@/components'

export default {
  components: {
    Badge
  },
  props: {
    game: Object,
    gameId: Number,
    stats: Object
  },
  data() {
    return {
      actualMinutes: 0
    }
  },
  methods: {
    dateFormat() {
      return moment(this.game.scheduledMatchDate).format('DD/MM/YYYY HH:mm')
    },
    async changeStatusGame(status) {
      const request = await this.$store.dispatch(status, {
        gameId: this.gameId,
        actualMinutes: this.actualMinutes
      })
      if (request != undefined) {
        this.$store.dispatch('getGame', { gameId: this.gameId })
        this.$notify({
          message: this.$t(`notifications.game.status.${status}`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  }
}
</script>

<style>
  .md-layout--status {
    box-shadow: none;
    border-radius: 8px 0 0 8px;
  }
  .title small {
    margin: 0 4px;
  }
</style>